module.exports = {
      id: "icon-timer-usage",
      viewBox: "0 0 15.177 16",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#icon-timer",
      toString: function () {
        return this.url;
      }
    }